<script setup lang="ts">
import ConnxIcon from '../Atoms/ConnxIcon.vue';
interface HelperMessage {
  title: string;
  description: string;
  iconPositionCss: string;
}
interface Props {
  messages: HelperMessage[];
}
defineProps<Props>();
</script>
<template>
  <div
    class="-tw-left-160 tw-absolute tw-bg-connx-white tw-w-152 tw-border tw-border-solid tw-border-connx-primary tw-rounded-lg"
  >
    <ol class="tw-mb-0">
      <li
        v-for="(message, index) in messages"
        :key="message.title"
        class="tw-relative tw-group hover:tw-bg-connx-primary hover:tw-text-connx-button-text tw-px-4 tw-py-2 tw-transition-all"
        :class="{
          'tw-mb-2': index + 1 !== messages.length,
        }"
      >
        <div
          :class="message.iconPositionCss"
          class="tw-absolute -tw-right-4 tw-bg-connx-primary tw-text-connx-button-text tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center group-hover:tw-animate-bounce-right tw-border-2 tw-border-solid tw-border-connx-white"
          :title="message.title"
        >
          <connx-icon name="fas fa-chevron-right"></connx-icon>
        </div>
        <strong class="group-hover:tw-text-connx-button-text"> {{ message.title }}: </strong>
        {{ message.description }}
      </li>
    </ol>
  </div>
</template>
